/**
 * Where an "Upgrade" action goes: always the in-app /upgrade page. React code
 * links to UPGRADE_PATH; non-React callers (the limit toasts) cannot navigate,
 * so they dispatch UPGRADE_NAVIGATE_EVENT through requestInAppUpgrade and
 * UpgradeNavigationListener opens the page.
 */
export const UPGRADE_PATH = "/upgrade"
export const UPGRADE_RETURN_PATH = "/upgrade/return"
export const UPGRADE_NAVIGATE_EVENT = "turnus:navigate-to-upgrade"

/** Asks the router (see UpgradeNavigationListener) to open the upgrade page. */
export function requestInAppUpgrade(): void {
  window.dispatchEvent(new CustomEvent(UPGRADE_NAVIGATE_EVENT))
}

// A Google sign-in leaves the app and comes back to its root, so a visitor sent
// to /upgrade (e.g. from the pricing page) would land on the start page.
// Email sign-in and the Microsoft popup keep the URL.
const UPGRADE_AFTER_SIGN_IN_KEY = "turnus-upgrade-after-sign-in"
const UPGRADE_AFTER_SIGN_IN_MAX_AGE_MS = 15 * 60 * 1000

/** Before a sign-in that leaves the app: remember a visitor on /upgrade. */
export function rememberUpgradeForSignIn(): void {
  if (window.location.pathname !== UPGRADE_PATH) return
  try {
    sessionStorage.setItem(UPGRADE_AFTER_SIGN_IN_KEY, String(Date.now()))
  } catch {
    // storage unavailable: the visitor lands on the start page
  }
}

/** True while such a sign-in should still end on /upgrade. Reads only, so it
 *  is safe during render; the upgrade page clears it. */
export function isUpgradePendingAfterSignIn(): boolean {
  try {
    const at = Number(sessionStorage.getItem(UPGRADE_AFTER_SIGN_IN_KEY))
    return at > 0 && Date.now() - at < UPGRADE_AFTER_SIGN_IN_MAX_AGE_MS
  } catch {
    return false
  }
}

export function clearUpgradeAfterSignIn(): void {
  try {
    sessionStorage.removeItem(UPGRADE_AFTER_SIGN_IN_KEY)
  } catch {
    // nothing to clear
  }
}
